<script>
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required, minLength, email } from '@vuelidate/validators';
import { useBranding } from 'shared/composables/useBranding';
import FormInput from '../../../../components/Form/Input.vue';
import { resetPassword } from '../../../../api/auth';
import AuthLayout from '../../../../components/AuthLayout.vue';
import AuthHeading from '../../../../components/AuthHeading.vue';
import AuthButton from '../../../../components/AuthButton.vue';
import AuthShowcase from '../../../../components/AuthShowcase.vue';

export default {
  components: { FormInput, AuthLayout, AuthHeading, AuthButton, AuthShowcase },
  setup() {
    const { replaceInstallationName } = useBranding();
    return { v$: useVuelidate(), replaceInstallationName };
  },
  data() {
    return {
      credentials: { email: '' },
      resetPassword: {
        message: '',
        showLoading: false,
      },
      error: '',
    };
  },
  validations() {
    return {
      credentials: {
        email: {
          required,
          email,
          minLength: minLength(4),
        },
      },
    };
  },
  methods: {
    showAlertMessage(message) {
      // Reset loading, current selected agent
      this.resetPassword.showLoading = false;
      useAlert(message);
    },
    submit() {
      this.resetPassword.showLoading = true;
      resetPassword(this.credentials)
        .then(res => {
          let successMessage = this.$t('RESET_PASSWORD.API.SUCCESS_MESSAGE');
          if (res.data && res.data.message) {
            successMessage = res.data.message;
          }
          this.showAlertMessage(successMessage);
        })
        .catch(error => {
          let errorMessage = this.$t('RESET_PASSWORD.API.ERROR_MESSAGE');
          if (error?.response?.data?.message) {
            errorMessage = error.response.data.message;
          }
          this.showAlertMessage(errorMessage);
        });
    },
  },
};
</script>

<template>
  <AuthLayout>
    <form @submit.prevent="submit">
      <AuthHeading
        :kicker="$t('TALKROBIN_AUTH.RESET.KICKER')"
        :title="$t('TALKROBIN_AUTH.RESET.TITLE')"
        :highlight="$t('TALKROBIN_AUTH.RESET.HIGHLIGHT')"
        :description="replaceInstallationName($t('RESET_PASSWORD.DESCRIPTION'))"
      />
      <div class="space-y-5">
        <FormInput
          v-model="credentials.email"
          name="email_address"
          type="email"
          autocomplete="email"
          :label="$t('LOGIN.EMAIL.LABEL')"
          :has-error="v$.credentials.email.$error"
          :error-message="$t('RESET_PASSWORD.EMAIL.ERROR')"
          :placeholder="$t('RESET_PASSWORD.EMAIL.PLACEHOLDER')"
          @input="v$.credentials.email.$touch"
        />
        <AuthButton
          data-testid="submit_button"
          class="!mt-7"
          :label="$t('RESET_PASSWORD.SUBMIT')"
          :disabled="v$.credentials.email.$invalid"
          :is-loading="resetPassword.showLoading"
        />
      </div>
      <router-link
        to="/app/login"
        class="inline-flex items-center gap-1.5 mt-6 text-sm font-semibold text-robin-indigo hover:text-robin-indigo-light dark:text-robin-indigo-light"
      >
        ← {{ $t('TALKROBIN_AUTH.RESET.BACK_TO_LOGIN') }}
      </router-link>
    </form>
    <template #aside>
      <AuthShowcase
        :title="$t('TALKROBIN_AUTH.LOGIN.SHOWCASE_TITLE')"
        :highlight="$t('TALKROBIN_AUTH.LOGIN.SHOWCASE_HIGHLIGHT')"
      />
    </template>
  </AuthLayout>
</template>
